import { useState } from 'react';
import { useLazyGetSlipPdfQuery } from '../../services/receiptApi';
import { useDownloadPDF } from '../useDownloadPDF';
import { useDownloadScreenshot } from '../useDownloadScreenshot';
export function useChargesCreated(id) {
    const [getPdfTrigger] = useLazyGetSlipPdfQuery();
    const { downloadScreenshot, downloadScreenshotRef } = useDownloadScreenshot({
        fileName: `qr-code-${id}.png`,
    });
    const { downloadPDF, createPDFBlob } = useDownloadPDF();
    const [showCopyAlert, setShowCopyAlert] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    async function downloadBillet() {
        setLoading(true);
        setError(false);
        try {
            const { data } = await getPdfTrigger({ slipId: id });
            if (data?.result?.data) {
                downloadPDF(createPDFBlob(data.result.data), `boleto-cobranca-${id}`);
            }
            else {
                setError(true);
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    function copyToClipboard(text) {
        navigator.clipboard.writeText(text);
        setShowCopyAlert(true);
    }
    return {
        error,
        setError,
        loading,
        setLoading,
        showCopyAlert,
        setShowCopyAlert,
        downloadBillet,
        downloadScreenshotRef,
        downloadScreenshot,
        copyToClipboard,
    };
}
